<p *ngIf="client">Soll der Mandant <b>{{client.name}}</b> wirklich erstellt werden?</p>
<div class="flex-between">
  <button mat-raised-button color="warn" (click)="closeBottomSheet()">Nein</button>
  <button mat-raised-button color="primary" (click)="addNewClient()">Ja</button>
</div>
